import { gql } from "@apollo/client";

const AllEndpoints = gql`
  query StatusQuery {
    workerCount
  }
`;

const hash = "8b86686381595285f79aee80ecd4faabbfd85018ebc8632aa16d9f2a39cd0108";

export { AllEndpoints, hash };
